// extracted by mini-css-extract-plugin
module.exports = {"svg-icon":"_2ae3b4","svg-icon_loader":"_8a55b6","rotator":"_4b6b71","svg-icon_logo":"f4d14c","svg-icon_avatar":"c1acbb","svg-icon_yellow":"_62e74d"};